/* schedules.icon.svg.js */

'use strict';
module.exports = {
    icon: `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 768 768">
    <title></title>
    <path class="foreground-gl" d="M640 96h-32v-64h-64v64h-320v-64h-64v64h-32c-35.2 0-64 28.8-64 64v512c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64zM640 672h-512v-416h512v416z"></path>
    </svg>
    `
};
